// extracted by mini-css-extract-plugin
module.exports = {"handle":"handle-d1e08a55fffbf05296e928403ac3c064"};